'use client';

import { useState } from 'react';
import { useUpdateChecker } from '@/hooks/use-update-checker';

export function UpdateBanner() {
  const [show, setShow] = useState(false);

  useUpdateChecker(() => setShow(true));

  if (!show) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex items-center gap-3 rounded-xl bg-primary px-4 py-3 text-primary-foreground shadow-lg animate-in slide-in-from-bottom-4">
      <span className="text-sm">发现新版本，刷新获取最新内容</span>
      <button
        onClick={() => window.location.reload()}
        className="rounded-lg bg-white/20 px-3 py-1 text-sm font-medium hover:bg-white/30 transition-colors"
      >
        刷新
      </button>
      <button
        onClick={() => setShow(false)}
        className="text-white/60 hover:text-white transition-colors"
        aria-label="关闭"
      >
        ✕
      </button>
    </div>
  );
}
